import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.page.html',
  styleUrls: ['./reset.page.scss'],
})
export class ResetPage  {
resetPasswordForm: FormGroup;
  errors = {};
  loaded=false
  constructor(
    private http: HttpClient,
    private errorHandlerSRV:ErrorHandlerService,
    private router:Router,
    public dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private loaderSRV:LoaderService,
    public translateService: TranslateService,
    private toastService: ToastService,
  ) { }
    
  token = { "_token": "" };
  

  async ionViewWillEnter() {
    this.loaded=false
    this.resetPasswordForm = this.fb.group({
        email: [null, [Validators.required]],
        password: [null, [Validators.required]],
        password_confirmation: [null, [Validators.required]],
        token:[this.route.snapshot.paramMap.get('token')]
       });
       this.loaded=true
       await Preferences.remove({ key: this.dataService.hash(environment.storageKey) });
   this.dataService.isAuthenticated.next(false)
       this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
       this.http
       .post(`${this.dataService.apiUrl}/api/v1/register`, null).subscribe( {
        next:data=>{
          this.token._token = data['state'].csrf_token
          this.loaderSRV.dismissLoader()
        },
        error:err=>{
          this.loaderSRV.dismissLoader()
        }
        
        


      })
 }
 onSubmit(){
  this. errors = {};
  this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
  const data = this.resetPasswordForm.value;

  this.dataService.postData('api/v1/public/password/reset', data).subscribe({
    next:(res:any) => {
      if(res['status']=='success'){
        this.router.navigate(['home']); 
       
        this.toastService.presentToast(res?.message);
        this.errors = {};
        this.resetPasswordForm.reset();
        this.loaderSRV.dismissLoader()
      } else {
        this.loaderSRV.dismissLoader()
        this.errorHandlerSRV.displayErrorMessage(data,true)

    }},
    error:(err) => {
      if(err?.errors){
        this.errors=err?.errors
      } else {
        this.errorHandlerSRV.displayErrorMessage(err, true)
      }
        
      
    }
  })
}

}
